import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; // ← necessario per *ngIf e *ngFor
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Dimension } from '../../models/dimension.model';
import { Question } from '../../models/question.model';
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { MatStepper, MatStep } from "@angular/material/stepper";
import { MatButtonModule } from "@angular/material/button";
import { MatStepperModule } from '@angular/material/stepper';
import { MatIcon } from '@angular/material/icon';

import {NgTemplateOutlet} from '@angular/common';
import { AuthService } from '../../service/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-questionnaire-trainee',
  standalone: true,
  imports: [MatRadioGroup, MatRadioButton, ReactiveFormsModule, MatStepper, MatStep, CommonModule, MatButtonModule, MatStepperModule, TranslateModule],
  templateUrl: './view-questionnaire-trainee.component.html',
  styleUrls: ['./view-questionnaire-trainee.component.css']
})
export class ViewQuestionnaireTraineeComponent implements OnInit {

  questions: Question[] = [];
  token: string = '';
  dimension: Dimension[] = [];
  dimensionForms: FormGroup[] = [];

  constructor(private http: HttpClient, private route: ActivatedRoute,    private fb: FormBuilder, private auth: AuthService,
    private translate: TranslateService
) {}

  ngOnInit(): void {

    this.auth.setLoggedIn(false);

    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      if (this.token) {
        this.loadQuestions();
      } else {
        console.error('Token mancante nella query string');
      }
    });
  }

  loadQuestions() {

        this.http.get<any[]>(`${environment.apiUrl}/api/questions/trainee?token=${this.token}`).subscribe((questions) => {
          console.log('Dati ricevuti dal backend:', questions); // <-- aggiungi questo
          const groupedDimensions = this.groupQuestionsByDimension(questions);
          this.dimension = groupedDimensions;
          this.initStepper(groupedDimensions);

          console.log('Grouped dimensions:', this.dimension);
          console.log('dentro ngoninit:', this.dimensionForms);


      });
   /*  this.http.get<Question[]>(`${environment.apiUrl}/api/questions/trainee?token=${this.token}`)
      .subscribe({
        next: (data) => {
          console.log('Dati ricevuti dal backend:', data); // <-- aggiungi questo
          this.questions = data;
        },
        error: (err) => console.error('Errore caricamento questionario', err)
    }); */
  }

    groupQuestionsByDimension(questions: any[]): Dimension[] {
    const groupedMap: { [key: string]: Dimension } = {};

    questions.forEach((q) => {
      const dimName = q.dimension.name;
      if (!groupedMap[dimName]) {
        groupedMap[dimName] = {
          dimensionName: dimName,
          dimensionCode: q.dimension.key,
          average: 0,
          questions: []
        };
      }

      groupedMap[dimName].questions.push({
        questionId: q.id,
        questionCode: q.code,
        questionText: q.text,
        answerValue: null
      });
    });

    return Object.values(groupedMap);
  }


  initStepper(dimensions: Dimension[]) {
    this.dimensionForms = [];

    dimensions.forEach((dim) => {
      const group: { [key: string]: any } = {};

      dim.questions.forEach((question, index) => {
        group[`question${index + 1}`] = this.fb.control(null, Validators.required);
      });

      this.dimensionForms.push(this.fb.group(group));
    });
  }

  submit() {
    const answers: { questionId: number; value: number }[] = [];

    this.dimension.forEach((dim, dimIndex) => {
      const formGroup = this.dimensionForms[dimIndex];
      dim.questions.forEach((question, qIndex) => {
        const value = formGroup.get(`question${qIndex + 1}`)?.value;
        if (value !== null && value !== undefined) {
          answers.push({
            questionId: question.questionId,
            value: value
          });
        }
      });
    });

    console.log('Risposte raccolte:', answers);
    console.log('token trainee:', this.token);

    // Esempio POST verso backend
    this.http.post(`${environment.apiUrl}/api/questionnaires/submit/trainee?token=${this.token}`, { answers },{ responseType: 'text' }).subscribe({
      next: (res) => {
        console.log('Risposta backend:', res);
        alert(this.translate.instant('view-questionnaire-trainee.submit-success'));
      },
      error: (err) => {
        console.error('Errore invio questionario', err);
        alert(this.translate.instant('view-questionnaire-trainee.submit-error'));
      }
    });

  }


}
